module.exports = __webpack_public_path__ + "img/slides.4a253d5b.png";